import {
	ExternalFormLandingsNS,
	externalFormLandingsSlice,
	landingApi,
	LandingModel,
} from 'Pages/orders'
import { call, put, takeLatest } from 'typed-redux-saga'
import { ResponseCatalog } from 'Models'
import { Deserialize } from 'cerialize'
import { errorHandler } from 'Modules'

function* getAll(action: ExternalFormLandingsNS.GetAll) {
	try {
		const { params } = action.payload
		const res = yield* call(landingApi.getAll, params)
		const items = new ResponseCatalog<LandingModel>(res)
		items.entries = items.entries.map((item): LandingModel => Deserialize(item, LandingModel))
		yield* put(externalFormLandingsSlice.actions.setAll(items))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

function* getSearch(action: ExternalFormLandingsNS.GetSearch) {
	try {
		const { params } = action.payload
		const res = yield* call(landingApi.getAll, params)
		const items = new ResponseCatalog<LandingModel>(res)
		items.entries = items.entries.map((item): LandingModel => Deserialize(item, LandingModel))
		yield* put(externalFormLandingsSlice.actions.setSearch(items))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const externalFormLandingSaga = function* saga() {
	yield* takeLatest(externalFormLandingsSlice.actions.getAll.type, getAll)
	yield* takeLatest(externalFormLandingsSlice.actions.getSearch.type, getSearch)
}
